import React from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import TextInput from '../../../../sharedModules/form/components/TextInput';
import InspectionRadioGroup from '../InspectionRadioGroup';
import { yesNoOptions } from '../../config/options';
import type { InspectionFormValues } from '../../utils/inspectionReportFormDefaults';
import { sectionHeaderSx } from './inspectionReportFormStyles';

interface CustomerInformationSectionProps {
  formValues: InspectionFormValues;
  headerDisabled: boolean;
  updateField: (field: string, value: unknown) => void;
  formatDate: (d: string) => string;
}

const CustomerInformationSection: React.FC<CustomerInformationSectionProps> = ({
  formValues,
  headerDisabled,
  updateField,
  formatDate,
}) => (
  <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
    <Typography sx={sectionHeaderSx}>Customer Information</Typography>
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Name"
            value={formValues.customerName}
            valueChanged={(val) => updateField('customerName', val)}
            disabled={headerDisabled}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Date"
            value={formatDate(formValues.date)}
            valueChanged={(val) => updateField('date', val)}
            disabled={headerDisabled}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Technician"
            value={formValues.technician}
            valueChanged={(val) => updateField('technician', val)}
            disabled={headerDisabled}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            label="Work Order Number"
            value={formValues.workOrderNumber}
            valueChanged={(val) => updateField('workOrderNumber', val)}
            disabled={headerDisabled}
          />
        </Grid>
        <Grid item xs={12}>
          <InspectionRadioGroup
            label="Offered Maintenance Plan"
            radioOptions={yesNoOptions}
            value={formValues.offeredMaintenancePlan}
            setValue={(val) => updateField('offeredMaintenancePlan', val)}
          />
        </Grid>
      </Grid>
    </Box>
  </Paper>
);

export default CustomerInformationSection;
